import { Injectable } from '@angular/core'

import { ApiService, Mapper, Store } from 'app/services'
import { ElectronicDocument } from 'app/models'

@Injectable({
  providedIn: 'root'
})
export class ElectronicDocumentService extends Store<ElectronicDocument> {

  constructor(private api: ApiService) {
    super(new ElectronicDocument({ }))
  }

  public findCurrent(id: string): void {
    this.api.get(`v3/electronic_documents/${id}`).subscribe(this.success, this.error.bind(this, id))
  }

  public findByWaiverId(boss_organization_id: string, id: string): void {
    this.api
      .get(`v3/electronic_documents?boss_organization_id=${boss_organization_id}&waiverId=${id}`)
      .subscribe(this.success)
  }

  private success = (data: any): void => {
    const { result } = data
    const model = Mapper.as<ElectronicDocument>(Array.isArray(result) ? result[0] : result, ElectronicDocument)
    model['metadata'] = data.metadata
    this.subject.next(model)
  }

  private error = (id: string): void => {
    this.api.get(`waivers/${id}`).subscribe((data: any) => {
      this.findByWaiverId(data.result.boss_organization_id, id)
    })
  }
}
